import { Component, AfterViewInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, Event, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LabelConstants } from './utilities/app-constants';
import { FolioHelperService } from './utilities/folio-helper.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements AfterViewInit {
  readonly MY_CONSTANT = LabelConstants;

  title = 'folio';
  showHeader = true;
  spinnerText = 'Loading...';

  constructor(
    private router: Router,
    private folioService: FolioHelperService,
    private spinner: NgxSpinnerService,
    private matSnackBar: MatSnackBar,
  ) {
    window.addEventListener('online', () => {
      this.matSnackBar.open('Connected back online', 'dismiss', {duration: 3000});
    });
    window.addEventListener('offline', () => {
      this.matSnackBar.open('No internet connection available!');
    });
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.showHeader = event.urlAfterRedirects !== '/login';
        this.showHeader = event.urlAfterRedirects !== '/reset-password';
        this.folioService.setSpinnerVisible(false);
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.folioService.showSpinner.subscribe((data) => {
        if (data.visible) {
          this.showSpinner();
        } else {
          this.hideSpinner();
        }
        this.spinnerText = data.text;
      });
    }, 500);
  }

  showSpinner() {
    this.spinner.show(undefined,
      {
        size: 'medium',
        bdColor: 'rgba(211,211,211, .8)',
        color: '#47ba7a',
        fullScreen: true
      }
    );
  }

  hideSpinner() {
    this.spinner.hide();
    this.spinnerText = '';
  }

}
